export default __webpack_public_path__ + "static/assets/med_capsule_V_tran_01_b_mask.1b874e5a.png";